import React, { useCallback, useEffect, useState } from 'react'
import {
    AppBar,
    CircularProgress,
    Container,
    Dialog,
    DialogContent,
    IconButton,
    Stack,
    Tab,
    Tabs,
    Toolbar,
    alpha,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useDispatch, useSelector } from 'react-redux';
import RepairRequestForm from '../Survey/RepairRequestForm';
import { dossiersActions } from '../../_actions/dossiers.actions';
import { useTranslation } from 'react-i18next';
import { getLocalStorageItem, setLocalStorageItem } from '../../_helpers';
import { apps, LOCAL_STORAGE_GRID_KEYS, userAccountRoleConstants, userAccountTypeConstants } from '../../_constants';
import DataGridV2 from '../../components/DataGridV2';
import { INITIAL_ROW_SELECTION_MODEL } from '../../components/DataGridV2/constants';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { Close } from '@mui/icons-material';
import { Box } from '@mui/material';
import { getAddRepairRequestBuildingColumns } from './addRepairRequestBuildingUtils';
import ProjectSelectionGrid from './ProjectSelectionGrid';
import { TABS } from './constant';

const checkBuildingForRole = (role, building) => building.roles && building.roles.includes(role);

export default function AddRepairRequest({ canProjectLevel, isOpenObjectModal, setIsOpenObjectModal, building, repairRequestCreateCallBack, handleCloseNewRepairRequestModal,...props }) {    
    const { drawingFiles, drawingFilesLoading, updateLoading } = useSelector(state => state.dossier);
    const { user } = useSelector(state => state.authentication);
    const app = useSelector((state) => state.app);
    const apiRef = useGridApiRef();
    const keyPrefix = app === apps.aftercare ? "AFTERCARE" : app === apps.constructionQuality ? "CONSTRUCTION_QUALITY" : "GENERAL";
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDrawingFiles, setSelectedDrawingFiles] = useState({ pages: 1 });
    const [currentPage, setCurrentPage] = useState(1);
    const [selected, setSelected] = useState(null);
    const [openRepairRequestMap, setOpenRepairRequestMap] = useState(false);
    const dispatch = useDispatch();
    const { all = [], loading } = useSelector(state => state.buildings);
    const classes = useStyles();
    const { t , i18n } = useTranslation();
    const [selectedObject, setSelectedObject] = useState(null);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [buildings, setBuildings] = useState([]);
    const [isBuyerOrPropertyManager, setIsBuyerOrPropertyManager] = useState(false);
    const isBuyer = user && user.type === userAccountTypeConstants.buyer;
     const [rowSelectionModel, setRowSelectionModel] = useState(INITIAL_ROW_SELECTION_MODEL);
     const [paginationModel, setPaginationModel] = useState(() => getLocalStorageItem(
            LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_BUILDINGS_PAGINATION[keyPrefix], undefined
     ))
     const [activeTab, setActiveTab] = useState(TABS.OBJECT);
     const isConstructionQualityApp = app === apps.constructionQuality;

    
    useEffect(() => {
        if (!!building) {
            handleSaveSelection(building);
        }
    }, []);

 
    useEffect(() => {
        const filteredBuildings = all.filter(building => {
        const isSiteManagerBuilding = isConstructionQualityApp 
            ? checkBuildingForRole(userAccountRoleConstants.siteManager, building)
            : checkBuildingForRole(userAccountRoleConstants.siteManager, building) && !building.isAfterCareStarted;
            const isAftercareEmployeeBuilding = checkBuildingForRole(userAccountRoleConstants.aftercareEmployee, building) && building.isAfterCareStarted;
            const isPropertyManagerBuilding = checkBuildingForRole(userAccountRoleConstants.propertyManager, building);
            return isSiteManagerBuilding || isAftercareEmployeeBuilding || isPropertyManagerBuilding;
        });
        setBuildings(
            filteredBuildings.map(a => ({
                ...a,
                id: a.buildingId,
                postcode: a.addressModel ? a.addressModel.postcode : "",
                place: a.addressModel ? a.addressModel.place : "",
                addressText: a.addressModel ? `${a.addressModel.street || ""}${a.addressModel.houseNo || ""}${a.addressModel.houseNoAddition || ""}`: "",
                }))
        );
    }, [all,isConstructionQualityApp]);

    useEffect(() => {
        if (!drawingFilesLoading && isLoading) {
            if (drawingFiles && drawingFiles.length) {
                setSelectedDrawingFiles({
                    ...drawingFiles[0],
                    groupBy: drawingFiles[0].isInternal ? 'Internal' : 'External'
                });
            } else {
                setSelectedDrawingFiles({});
            }
            setTimeout(() => {
                setIsLoading(false);
                setOpenRepairRequestMap(true);
                handleCloseObjectModal();
            }, 100)
        }
    }, [isLoading, drawingFilesLoading, drawingFiles]);

    const handleCloseObjectModal = () => {
        setActiveTab(TABS.OBJECT);
        setIsOpenObjectModal(false);
    }
   

    const onPaginationModelChange = useCallback((newPaginationModel) => {
            setPaginationModel(newPaginationModel)
            setLocalStorageItem(
                LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_BUILDINGS_PAGINATION[keyPrefix],
                newPaginationModel
            );
    }, [keyPrefix])

    const handleSaveSelection  = (data) => {
        setIsLoading(true);
        setSelectedObject(data)
        setSelected(data)
        setIsBuyerOrPropertyManager(isBuyer || (data.roles && data.roles.length === 1 && data.roles.includes(userAccountRoleConstants.propertyManager)));
        dispatch(dossiersActions.getDrawingFiles(data.projectId, data.buildingId));
    };

 const columns = getAddRepairRequestBuildingColumns({t,keyPrefix,i18n,apiRef})
    return (
        <Container>
            <Dialog
                fullScreen={isMobile}
                classes={{ paper: classes.dialog, paperFullScreen: classes.paperFullScreen }}
                open={!!isOpenObjectModal}
                onClose={updateLoading || isLoading ? () => { } : handleCloseObjectModal}
                aria-labelledby="form-dialog-title"
                maxWidth='lg'
                scroll="paper"
            >
                <AppBar position='relative' sx={{ boxShadow: 'none' }}>
                    <Toolbar >
                        <Stack >
                            <Stack direction={"row"} alignItems={"center"}>
                                <IconButton
                                    onClick={handleCloseObjectModal}
                                    aria-label="close"
                                    color="inherit"
                                    edge="start"
                                >
                                    <Close />
                                </IconButton>
                                 <Tabs
                                    value={activeTab}
                                    onChange={(e, newValue) => setActiveTab(newValue)}
                                    sx={{ ml: 2,
                                         '& .MuiTabs-indicator': {
                                        backgroundColor: 'common.white',
                                    },
                                    }}
                                    textColor='inherit'
                                    aria-label='scrollable auto tabs example'
                                    >
                                    <Tab label={t("general.object.select")} />
                                   {isConstructionQualityApp && (
                                        <Tab label={t("constructionquality.selectProject")} />
                                    )}
                                    </Tabs>
                            </Stack>
                        </Stack>
                    </Toolbar>
                </AppBar>
                <DialogContent sx={{ p: 2 }}>
                    <Box height={'100%'}>
                    {isOpenObjectModal && activeTab === TABS.OBJECT &&  <DataGridV2
                        localSearchIdentifier={LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_BUILDINGS_SEARCH_TEXT[keyPrefix]}
                        localColumnFilterIdentifier={LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_FILTER[keyPrefix]}
                        localColumnSortIdentifier={LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_SORT[keyPrefix]}
                        localColumnOrderIdentifier={LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_ORDER[keyPrefix]}
                        localColumnWidthIdentifier={LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_WIDTH[keyPrefix]}
                        localColumnVisibilityIdentifier={LOCAL_STORAGE_GRID_KEYS.ADD_REPAIR_REQUEST_BUILDINGS_COLUMN_VISIBILITY[keyPrefix]}
                        apiRef={apiRef}
                        rows={buildings}
                        columns={columns}
                        loading={loading}
                        pagination
                        filterMode="client"
                        {...(!!paginationModel && { paginationModel })}
                        onPaginationModelChange={onPaginationModelChange}
                        rowSelectionModel={rowSelectionModel}
                        onRowSelectionModelChange={(newRowSelectionModel) => {
                            setRowSelectionModel(newRowSelectionModel);
                        }}
                        toolbarProps={{
                            selectedRows: rowSelectionModel,
                            title: t("general.object.select"),
                        }}
                        onRowClick={(params) => {
                        if (!loading) {
                        const buildingId = params.row.buildingId;
                        const buildingData = buildings.find((x) => x.buildingId === buildingId);
                        if (buildingData) handleSaveSelection (buildingData);
                        }
                        }}
                    /> 
                    }
                   </Box>
                </DialogContent>
                {(updateLoading || isLoading) && <div className={classes.loaderContainer}>
                    <CircularProgress size={30} />
                </div>}

                {isOpenObjectModal && activeTab === TABS.PROJECT && isConstructionQualityApp &&  (
                <ProjectSelectionGrid
                    onSelectProject={handleSaveSelection}
                />
                )}

            </Dialog >
           
            <RepairRequestForm
                isBuyerOrPropertyManager={isBuyerOrPropertyManager}
                setSelectedDrawingFiles={setSelectedDrawingFiles}
                setCurrentPage={setCurrentPage}
                buildingId={selectedObject && selectedObject.buildingId}
                projectId={selected && selected.projectId}
                selectedProjectId={(selected && selected.projectId) || (selectedObject && selectedObject.projectId)}
                selectedDrawingFiles={selectedDrawingFiles}
                currentPage={currentPage}
                redirectToMomentDetail={console.log}
                onPreview={console.log}
                setID={(id) => console.log(id)}
                canSelectSortManual
                // setIsRepairRequest={(data) => setIsRepairRequest(data)}
                openRepairRequestMap={openRepairRequestMap}
                onClose={(reload) => {
                    reload && repairRequestCreateCallBack();
                    setOpenRepairRequestMap(false)
                    setCurrentPage(1)
                    handleCloseNewRepairRequestModal  && handleCloseNewRepairRequestModal()
                }}
            />
        </Container>
    )
}


const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1
    },
    loaderContainer: {
        display: "flex",
        position: "absolute",
        height: "100%",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: alpha(theme.palette.common.black, 0.20),
        zIndex: theme.zIndex.drawer
    },
    dialog: {
        width: "60vw",
        height: "100%",
        overflow: "hidden"
    },
    mainContainer: {
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(2),
        height: "100%"
    },
    paperFullScreen: {
        width: "100% !important"
    },
}));